// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'object-status';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M1.031 8.823h2.48a1.063 1.063 0 0 0 .98-.654l1.842-4.331a.531.531 0 0 1 .992.036l3.353 10.43a.532.532 0 0 0 .992.036l1.838-4.863a1.063 1.063 0 0 1 .98-.654h2.48'
  />
);

export const viewBox = '0 0 18 18';
